import Link from "next/link";
import React, { ReactElement } from "react";
import styles from "./contactOption.module.scss";

export const ContactOption = (props: Props): ReactElement => {
  const Icon = props.icon;

  return (
    <div className={styles.container} style={props.style}>
      <Icon className={styles.icon} />
      <p className={styles.title}>{props.title}</p>
      <p className={styles.desc}>{props.desc}</p>

      {props.href && (
        <Link href={props.href} className={styles.value}>
          {props.value}
        </Link>
      )}
      {props.onClick && <button className={styles.value}>{props.value}</button>}
    </div>
  );
};

interface Props {
  icon: React.ElementType;
  title: string;
  desc: string;
  value?: string;
  href?: string;
  onClick?: () => void;
  style?: any;
}
